import { useMutation } from 'react-query'
import { request } from '../request'

export const useAuthGenerateResetToken = () => {
  return useMutation((data: { email: string }) =>
    request({
      url: '/auth/generate-token',
      method: 'POST',
      data: data,
    }),
  )
}
